type NullableString = string | null;
type NullableBoolean = boolean | null;
type NullableNumber = number | null;
type NullableDateTime = Date | null;

export type SocItemDetailsAo = {
  id: string;
  socId: string;
  currentCompliant: NullableBoolean;
  currentNonComplianceDescription: NullableString;
  currentNonComplianceNonOfqualConditions: NullableString;
  currentNonComplianceMitigation: NullableString;
  currentCompliantDate: NullableDateTime;
  futureCompliant: NullableBoolean;
  futureNonComplianceNonOfqualConditions: string;
  futureNonComplianceDescription: NullableString;
  futureNonComplianceHow: NullableString;
  futureNonComplianceMitigation: NullableString;
  totalRevenue: NullableNumber;
  totalExpenditure: NullableNumber;
  netProfit: NullableNumber;
  cashInHand: NullableNumber;
  annualFixedCosts: NullableNumber;
  fullAccountsUpload: SocOrganisationStability | null;
  govBodyConfirmCompliance: NullableBoolean;
  govBodyNoCompliance: NullableString;
  govBodyConfirmApproval: NullableBoolean;
  govBodyConfirmNoApproval: NullableString;
  govBodyConfirmChairRo: NullableBoolean;
  govBodyConfirmNoChairRo: NullableString;
  govBodyConfirmNameRo: NullableString;
  govBodyConfirmNameChair: NullableString;
  socCurrentNonComplianceGeneralConditions: number[];
  socCurrentNonComplianceQualConditions: number[];
  socCurrentNonComplianceSubjectConditions: number[];
  socFutureNonComplianceGeneralConditions: number[];
  socFutureNonComplianceQualConditions: number[];
  socFutureNonComplianceSubjectConditions: number[];
  socActiveSubmissions: SocItemFile[],
  accountStatementAttachment: File | null;
  kloe1Attachment: File | null;
  kloe2Attachment: File | null;
  kloe3Attachment: File | null;
  fullAccountsUploadDescription: NullableString;
};

export const requiredOfqualFields: (keyof SocItemDetailsAo)[] = [
  "currentCompliant",
  "currentNonComplianceDescription",
  "currentNonComplianceNonOfqualConditions",
  "currentNonComplianceMitigation",
  "currentCompliantDate",
  "futureCompliant",
  "futureNonComplianceNonOfqualConditions",
  "futureNonComplianceDescription",
  "futureNonComplianceHow",
  "futureNonComplianceMitigation",
  "totalRevenue",
  "totalExpenditure",
  "netProfit",
  "cashInHand",
  "annualFixedCosts",
  "fullAccountsUpload",
  "govBodyConfirmCompliance",
  "govBodyNoCompliance",
  "govBodyConfirmApproval",
  "govBodyConfirmNoApproval",
  "govBodyConfirmChairRo",
  "govBodyConfirmNoChairRo",
  "govBodyConfirmNameRo",
  "govBodyConfirmNameChair",
  "socCurrentNonComplianceGeneralConditions",
  "socCurrentNonComplianceQualConditions",
  "socCurrentNonComplianceSubjectConditions",
  "socFutureNonComplianceGeneralConditions",
  "socFutureNonComplianceQualConditions",
  "socFutureNonComplianceSubjectConditions",
  "socActiveSubmissions",
  "accountStatementAttachment",
  "kloe1Attachment",
  "kloe2Attachment",
  "kloe3Attachment",
  "fullAccountsUploadDescription"
];

export const defaultSocItemValuesAo: SocItemDetailsAo = {
  id: "",
  socId: "",
  currentCompliant: null,
  currentNonComplianceDescription: null,
  currentNonComplianceNonOfqualConditions: null,
  currentNonComplianceMitigation: null,
  currentCompliantDate: null,
  futureCompliant: null,
  futureNonComplianceNonOfqualConditions: "",
  futureNonComplianceDescription: null,
  futureNonComplianceHow: null,
  futureNonComplianceMitigation: null,
  totalRevenue: null,
  totalExpenditure: null,
  netProfit: null,
  cashInHand: null,
  annualFixedCosts: null,
  fullAccountsUpload: null,
  govBodyConfirmCompliance: null,
  govBodyNoCompliance: null,
  govBodyConfirmApproval: null,
  govBodyConfirmNoApproval: null,
  govBodyConfirmChairRo: null,
  govBodyConfirmNoChairRo: null,
  govBodyConfirmNameRo: null,
  govBodyConfirmNameChair: null,
  socActiveSubmissions: [],
  socCurrentNonComplianceGeneralConditions: [],
  socCurrentNonComplianceQualConditions: [],
  socCurrentNonComplianceSubjectConditions: [],
  socFutureNonComplianceGeneralConditions: [],
  socFutureNonComplianceQualConditions: [],
  socFutureNonComplianceSubjectConditions: [],
  accountStatementAttachment: null,
  kloe1Attachment: null,
  kloe2Attachment: null,
  kloe3Attachment: null,
  fullAccountsUploadDescription: null
};

export type SocItemFile = {
  id: string;
  socId: string;
  submissionType: string;
  fileName: string;
  blobId: string;
  contentType: string;
  createdDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedDate: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  dateSubmmitted: NullableString;
  active: NullableBoolean;
}

export enum SocOrganisationStability {
  fullAccountsUploadYes = 1,
  fullAccountsUploadEndJanuary = 2,
  fullAccountsUploadNoCircumstances = 3,
  fullAccountsUploadEndFebruary = 4,
  fullAccountsUploadEndMarch = 5
}